import { useState } from 'react'
import { motion } from 'framer-motion'
import { QRCodeSVG } from 'qrcode.react'
import { Check, Copy, ExternalLink, Download } from 'lucide-react'
import Button from '../ui/Button.jsx'
import Modal from '../ui/Modal.jsx'
import { useToast } from '../ui/Toast.jsx'

function CopyField({ label, value }) {
  const [copied, setCopied] = useState(false)
  const toast = useToast()
  function copy() {
    navigator.clipboard.writeText(value)
    setCopied(true)
    toast('Copied to clipboard', 'success')
    setTimeout(() => setCopied(false), 1600)
  }
  return (
    <div className="mb-4">
      <div className="text-[11px] font-semibold tracking-wide uppercase text-muted mb-1.5">{label}</div>
      <div className="flex items-center gap-2">
        <code className="flex-1 text-[12.5px] bg-panel2 border border-line rounded-md px-3 py-2.5 truncate">{value}</code>
        <button onClick={copy} className="w-10 h-10 shrink-0 rounded-md bg-panel2 border border-line hover:border-sky/40 flex items-center justify-center transition-colors">
          {copied ? <Check size={15} className="text-ok" /> : <Copy size={15} />}
        </button>
      </div>
    </div>
  )
}

export default function PublishedScreen({ open, onClose, url, title, onDownloadZip, downloadingZip }) {
  if (!open) return null
  const embed = `<iframe src="${url}" style="width:100%;height:80vh;border:0" allow="fullscreen"></iframe>`

  return (
    <Modal open={open} onClose={onClose} title="" width={480}>
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.35, ease: [0.34, 1.4, 0.64, 1] }}
        className="text-center mb-6"
      >
        <div className="w-14 h-14 rounded-full bg-ok/15 text-ok flex items-center justify-center mx-auto mb-4">
          <Check size={28} strokeWidth={2.5} />
        </div>
        <h2 className="font-display font-bold text-[20px] mb-1">Published!</h2>
        <p className="text-muted text-[13.5px]">"{title}" is live and ready to share.</p>
      </motion.div>

      <div className="flex justify-center mb-6">
        <div className="p-3 bg-white rounded-md">
          <QRCodeSVG value={url} size={128} />
        </div>
      </div>

      <CopyField label="Hosted URL" value={url} />
      <CopyField label="Embed code" value={embed} />

      <div className="flex gap-2 mt-6">
        <a href={url} target="_blank" rel="noreferrer" className="flex-1">
          <Button variant="primary" icon={ExternalLink} className="w-full">View live</Button>
        </a>
        <Button variant="ghost" icon={Download} onClick={onDownloadZip} loading={downloadingZip}>
          Download .zip
        </Button>
      </div>
    </Modal>
  )
}
